export var getTemporaryTwoFaUser = function (state) {
    return state.twoFa.twoFaOnLogin.temporaryUser;
};
export var getLoginRedirectObject = function (state) {
    return state.twoFa.twoFaOnLogin.redirectObject;
};
export var getTemporaryTwoFaUserToken = function (state) {
    return state.twoFa.twoFaOnLogin.temporaryToken;
};
export var getTemporaryTwoFaUserTokenExpiresAt = function (state) {
    return state.twoFa.twoFaOnLogin.temporaryTokenExpiresAt;
};
export var getTwoFaReturnLoginUrl = function (state) {
    return state.twoFa.twoFaOnLogin.loginUrl;
};
